import { Button } from '@wellesley/ui'
import { CircleCheck, CircleHelp, CircleX } from 'lucide-react'
import { FC } from 'react'
import {
  usePostApiV1EventsByEventIdAcceptMutation,
  usePostApiV1EventsByEventIdRejectMutation,
  usePostApiV1EventsByEventIdMaybeMutation,
} from '@wellesley/events'
import { notificationsSlice } from '../../../slice'
import { useDispatch } from 'react-redux'
import { EventResponse, NotificationItem } from '../../../types'
import { logger } from 'helpers/logger'

type EventInvitaionControlsProps = {
  notification: NotificationItem
}

const EventInvitaionControls: FC<EventInvitaionControlsProps> = ({
  notification,
}) => {
  const dispatch = useDispatch()

  const [acceptEvent] = usePostApiV1EventsByEventIdAcceptMutation()
  const [rejectEvent] = usePostApiV1EventsByEventIdRejectMutation()
  const [maybeEvent] = usePostApiV1EventsByEventIdMaybeMutation()

  const response =
    notification.eventResponse || notification.meta?.actionsTaken?.[0].text

  const responseMessage = response ? `You said: ${response}` : ''

  const updateNotification = (response: EventResponse) => {
    dispatch(
      notificationsSlice.actions.updateNotification({
        ...notification,
        eventResponse: response,
      }),
    )
  }

  const onAccept = () => {
    try {
      if (!notification.activityId) return
      void acceptEvent({ eventId: notification.activityId }).unwrap()
      updateNotification('Yes')
    } catch (error) {
      logger.error(`Error accepting event: ${JSON.stringify(error)}`)
    }
  }
  const onReject = () => {
    if (!notification.activityId) return
    try {
      void rejectEvent({ eventId: notification.activityId }).unwrap()
      updateNotification('No')
    } catch (error) {
      logger.error(`Error rejecting event: ${JSON.stringify(error)}`)
    }
  }
  const onMaybe = () => {
    if (!notification.activityId) return
    try {
      void maybeEvent({ eventId: notification.activityId }).unwrap()
      updateNotification('Maybe')
    } catch (error) {
      logger.error(`Error maybe event: ${JSON.stringify(error)}`)
    }
  }

  return (
    <div className="gap-xs flex items-center">
      {response ? (
        <span className="text-xs font-medium uppercase text-gray-500">
          {responseMessage}
        </span>
      ) : (
        <>
          <Button
            size="s"
            className="min-w-0"
            variant="secondary"
            onClick={onAccept}
          >
            <CircleCheck size={16} /> Yes
          </Button>
          <Button
            size="s"
            className="min-w-0"
            variant="secondary"
            onClick={onMaybe}
          >
            <CircleHelp size={16} /> Maybe
          </Button>
          <Button
            size="s"
            className="min-w-0"
            variant="secondary"
            onClick={onReject}
          >
            <CircleX size={16} /> No
          </Button>
        </>
      )}
    </div>
  )
}

export default EventInvitaionControls
